import { useCallback } from 'react'

import { FormApi } from '@workwave-tidal/core/form'

import { useControllerById } from '../../../hooks/useController'
import { AdjustAddressFormValues } from '../types'

/**
 * It handles the form submit logic
 * @param onChange
 */
export function useOnSubmit(
  pinId:
    | 'depotFormPin'
    | 'placeFormPin'
    | 'geofenceFormPin'
    | 'orderForm_pickup'
    | 'orderForm_service'
    | 'orderForm_delivery',
  onChange: (payload: uui.domain.client.Location) => void,
  label: string,
  formApi: FormApi<AdjustAddressFormValues> | null,
) {
  const { update, close } = useControllerById(pinId)

  return useCallback(async () => {
    if (!formApi) {
      console.error('Form API is not available')
      return
    }

    // Set FormState submitting mode
    formApi.setSubmitting(true)
    update({ status: 'submitting' })

    // Validate form
    const valid = await formApi.validate()

    // If form is invalid, clear FormState submitting mode
    if (!valid) {
      formApi.setSubmitting(false)
      update({ status: 'ready' })
      return
    }

    // Get form values
    const { newLocation: newLocationFieldValue, keepLocationAddress } = formApi.getValues()

    const newLocation = keepLocationAddress
      ? newLocationFieldValue
      : { ...newLocationFieldValue, address: label }

    // Update the form values
    onChange(newLocation)

    // Clear FormState submitting mode
    formApi.setSubmitting(false)
    update({ status: 'ready' })

    // Close the modal
    close?.()
  }, [formApi, close, update, onChange])
}
